<div class="container-fluid">
  <!-- Page Header -->
  <app-page-header
    title="Configuração WhatsApp"
    icon="mdi mdi-whatsapp"
    subtitle="Gerencie a conexão do WhatsApp e escaneie o QR Code para conectar">
  </app-page-header>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">
              <i class="mdi mdi-whatsapp text-success me-2"></i>
              Status da Conexão
            </h4>
            <button 
              class="btn btn-outline-primary btn-sm" 
              (click)="refreshStatus()" 
              [disabled]="isLoading || isWaitingForQRCode">
              <i class="mdi mdi-refresh" [class.mdi-spin]="isLoading || isWaitingForQRCode"></i>
              {{ isWaitingForQRCode ? 'Aguardando QR Code...' : 'Atualizar' }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <!-- Status Cards -->
          <div class="row mb-4">
            <!-- Status da Conexão Card -->
            <div class="col-xl-4 col-md-6 mb-3">
              <div class="card status-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="avatar-sm">
                        <span class="avatar-title rounded-circle fs-2"
                              [ngClass]="{
                                'bg-success-subtle text-success': status === 'connected' || status === 'WORKING',
                                'bg-danger-subtle text-danger': status === 'disconnected',
                                'bg-warning-subtle text-warning': status === 'qr_ready' || status === 'initializing',
                                'bg-primary-subtle text-primary': status && status !== 'connected' && status !== 'disconnected' && status !== 'qr_ready' && status !== 'initializing' && status !== 'WORKING'
                              }">
                          <i class="mdi" 
                             [class.mdi-check-circle]="status === 'connected' || status === 'WORKING'"
                             [class.mdi-close-circle]="status === 'disconnected'"
                             [class.mdi-qrcode]="status === 'qr_ready'"
                             [class.mdi-loading]="status === 'initializing'"
                             [class.mdi-spin]="status === 'initializing'"
                             [class.mdi-information-outline]="status && status !== 'connected' && status !== 'disconnected' && status !== 'qr_ready' && status !== 'initializing' && status !== 'WORKING'"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h6 class="text-muted mb-2 font-size-12 text-uppercase">Status da Conexão</h6>
                      <h4 class="mb-0" 
                          [class.text-success]="status === 'connected' || status === 'WORKING'"
                          [class.text-danger]="status === 'disconnected'"
                          [class.text-warning]="status === 'qr_ready' || status === 'initializing'"
                          [class.text-primary]="status && status !== 'connected' && status !== 'disconnected' && status !== 'qr_ready' && status !== 'initializing' && status !== 'WORKING'">
                        {{ getStatusText() }}
                      </h4>
                      <!-- <span class="badge mt-2"
                            [class.bg-success-subtle]="status === 'connected' || status === 'WORKING'"
                            [class.text-success]="status === 'connected' || status === 'WORKING'"
                            [class.bg-danger-subtle]="status === 'disconnected'"
                            [class.text-danger]="status === 'disconnected'"
                            [class.bg-warning-subtle]="status === 'qr_ready' || status === 'initializing'"
                            [class.text-warning]="status === 'qr_ready' || status === 'initializing'"
                            [class.bg-primary-subtle]="status && status !== 'connected' && status !== 'disconnected' && status !== 'qr_ready' && status !== 'initializing' && status !== 'WORKING'"
                            [class.text-primary]="status && status !== 'connected' && status !== 'disconnected' && status !== 'qr_ready' && status !== 'initializing' && status !== 'WORKING'">
                        {{ status === 'WORKING' ? 'ONLINE' : status }}
                      </span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Account Info Card (when connected) -->
            <div class="col-xl-4 col-md-6 mb-3" *ngIf="(status === 'connected' || status === 'WORKING') && phoneNumber">
              <div class="card status-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-info-subtle text-info rounded-circle fs-2">
                          <i class="mdi mdi-account-circle"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h6 class="text-muted mb-2 font-size-12 text-uppercase">Conta Conectada</h6>
                      <h5 class="mb-1 text-truncate">{{ phoneNumber }}</h5>
                      <small class="text-muted d-block" *ngIf="connectedAt">
                        <i class="mdi mdi-clock-outline me-1"></i>
                        Conectado em {{ connectedAt | date:'short' }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- QR Code Section -->
          <div class="row mb-4" *ngIf="qrCode != null || status === 'initializing'">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">
                    <i class="mdi mdi-qrcode me-2 text-primary"></i>
                    QR Code para Conexão
                  </h5>
                </div>
                <div class="card-body text-center">
                  <div *ngIf="qrCode; else noQrCode" class="qr-code-container">
                    <img [src]="qrCode" alt="WhatsApp QR Code" class="img-fluid qr-code-image mb-3">
                    <div class="alert alert-info">
                      <h6 class="alert-heading">
                        <i class="mdi mdi-information me-2"></i>
                        Como conectar:
                      </h6>
                      <ol class="mb-0 text-start" style="display: inline-block;">
                        <li>Abra o WhatsApp no seu celular</li>
                        <li>Toque em <strong>Menu</strong> ou <strong>Configurações</strong></li>
                        <li>Toque em <strong>Aparelhos conectados</strong></li>
                        <li>Toque em <strong>Conectar um aparelho</strong></li>
                        <li>Aponte seu celular para esta tela para capturar o código</li>
                      </ol>
                    </div>
                    <button class="btn btn-outline-primary btn-sm mt-2" (click)="loadQRCode()" [disabled]="isLoading">
                      <i class="mdi mdi-refresh me-1"></i>
                      Atualizar QR Code
                    </button>
                  </div>
                  <ng-template #noQrCode>
                    <div class="text-center py-5">
                      <div class="spinner-border text-primary mb-3" role="status" *ngIf="isLoading">
                        <span class="visually-hidden">Carregando...</span>
                      </div>
                      <p class="text-muted mb-2" *ngIf="isLoading">Gerando QR Code...</p>
                      <p class="text-muted mb-3" *ngIf="!isLoading">
                        <i class="mdi mdi-alert-circle me-2"></i>
                        QR Code não disponível. Tente reconectar.
                      </p>
                      <button class="btn btn-primary" (click)="reconnect()" [disabled]="isConnecting">
                        <i class="mdi mdi-refresh me-1"></i>
                        {{ isConnecting ? 'Conectando...' : 'Reconectar' }}
                      </button>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        
          <!-- Action Buttons -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">
                    <i class="mdi mdi-cog me-2"></i>
                    Ações
                  </h5>
                </div>
                <div class="card-body">
                  <div class="d-flex gap-2 flex-wrap">
                    <!-- Reconnect Button -->
                    <button 
                      class="btn btn-primary"
                      (click)="reconnect()"
                      [disabled]="isConnecting || isDisconnecting || isLoading">
                      <span *ngIf="isConnecting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <i class="mdi mdi-refresh me-1" *ngIf="!isConnecting"></i>
                      {{ isConnecting ? 'Conectando...' : 'Reconectar' }}
                    </button>
                    
                    <!-- Disconnect Button -->
                    <button 
                      class="btn btn-danger"
                      (click)="disconnect()"
                      [disabled]="status !== 'connected' || isConnecting || isDisconnecting || isLoading">
                      <span *ngIf="isDisconnecting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <i class="mdi mdi-logout me-1" *ngIf="!isDisconnecting"></i>
                      {{ isDisconnecting ? 'Desconectando...' : 'Desconectar' }}
                    </button>
                    
                    <!-- Refresh Status Button -->
                    <button 
                      class="btn btn-outline-secondary"
                      (click)="refreshStatus()"
                      [disabled]="isLoading || isConnecting || isDisconnecting || isWaitingForQRCode">
                      <span *ngIf="isLoading || isWaitingForQRCode" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <i class="mdi mdi-refresh me-1" *ngIf="!isLoading && !isWaitingForQRCode"></i>
                      {{ isWaitingForQRCode ? 'Aguardando QR Code...' : (isLoading ? 'Carregando...' : 'Atualizar Status') }}
                    </button>
                  </div>
                  
                  <!-- Help Text -->
                  <div class="mt-3">
                    <div class="alert alert-light border">
                      <h6 class="alert-heading mb-2">
                        <i class="mdi mdi-information me-2"></i>
                        Instruções:
                      </h6>
                      <ul class="mb-0 small">
                        <li>Use <strong>Reconectar</strong> para inicializar uma nova conexão do WhatsApp</li>
                        <li>Use <strong>Desconectar</strong> para sair da sessão atual do WhatsApp</li>
                        <li>Escaneie o código QR com seu aplicativo móvel WhatsApp</li>
                        <li>O status é atualizado automaticamente enquanto não estiver conectado</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Configurações Section -->
          <div class="row mt-4">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">
                    <i class="mdi mdi-cog-outline me-2"></i>
                    Configurações
                  </h5>
                </div>
                <div class="card-body">
                  <div class="settings-list">
                    <!-- Quantidade de chamados simultâneo por atendente -->
                    <div class="settings-item">
                      <div class="d-flex align-items-start justify-content-between">
                        <div class="flex-grow-1 me-3">
                          <label class="settings-label d-block">
                            Quantidade de chamados simultâneo por atendente
                          </label>
                          <p class="settings-description text-muted mb-0 small">
                            Define o número máximo de conversas que um atendente pode atender simultaneamente
                          </p>
                        </div>
                        <div class="flex-shrink-0">
                          <div class="input-group" style="width: 140px;">
                            <input 
                              type="number" 
                              class="form-control text-center" 
                              [(ngModel)]="quantidadeChamadosSimultaneos"
                              min="1"
                              max="100"
                              placeholder="1"
                              [disabled]="isLoadingConfig">
                            <span class="input-group-text">chamados</span>
                          </div>
                          <small class="text-muted d-block mt-1" *ngIf="isLoadingConfig">
                            <i class="mdi mdi-loading mdi-spin me-1"></i>
                            Carregando...
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Botão Salvar -->
                  <div class="mt-4 pt-3 border-top">
                    <button 
                      class="btn btn-primary"
                      (click)="salvarConfiguracoes()"
                      [disabled]="isSavingConfig || isLoadingConfig">
                      <span *ngIf="isSavingConfig" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      <i class="mdi mdi-content-save me-1" *ngIf="!isSavingConfig"></i>
                      {{ isSavingConfig ? 'Salvando...' : 'Salvar Configurações' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>